<template>
    <div class="container-fluid mt-4">
        
      <div class="row d-flex justify-content-between">
                <div class="col-5">
                    <img class="img-rounded" src="@/assets/images/sick.png" height="50px" /><br>
                    <table class="table" density="compact" style="color:black">
                    <tr><td>Full Name: </td><td class="h5"> {{ patientData.name }}</td></tr>
                    <tr><td>Gender: </td><td class="h6"> {{ patientData.gender }} </td> </tr>
                    <tr><td> Telephone: </td><td class="h6"> 0{{ patientData.telephone }} </td></tr>
                    <tr><td> Age: </td><td class="h6"> {{ getAge(patientData.date_of_birth) }}  </td></tr>
                    <tr><td> Address: </td><td class="h6"> {{ patientData.address }} </td></tr>
                  </table>
                </div>
                <div class="col-4">
                  <span v-if="userData.logo!=0"><img :src="getLogo(userData.logo)" height="50px"/></span>
                    <span v-else><img src="@/assets/images/logo.png" height="50"/></span>
                    <h4 style="color:black" class="text-uppercase">{{ userData.business }}</h4>
                    <span style="color:black;font-size:13px">Location : {{ userData.location }}</span><br>
                    <span style="color:black;font-size:13px">Telephone : {{ userData.contact }}</span><br>
                    <span style="color:black;font-size:13px">Email : {{ userData.email }}</span><br>
                    <span style="color:black;font-size:13px">Website : {{ userData.website }}</span><br>
                    <span v-if="userData.slogan" style="color:black;font-size:13px;font-style:italic">Slogan: {{ userData.slogan }}</span><br>
                </div>
              </div>
              <h6 class="mt-2 text-center">Date : {{ visit_date }}</h6>
              <h4 class="mt-2 text-center text-decoration-underline">Laboratory Results</h4>

              <div class="my-2">
                <table class="table table-sm mt-2" style="color: black;" density="compact">
                  <thead><tr><th>Test</th><th>Sample</th><th>Results</th></tr></thead>
                  <tbody>
                    <tr v-for="item in patientTest" :key="item.id">
                      <!-- <td>{{ item.test.name }}</td> -->
                      <td>
            <!-- Display test name and service price if available -->
            <!-- <template v-if="item.test">
                {{ item.test.name }} <br><b class="small">{{ commas(item.test.serviceprice) }}</b>
            </template>
            <template v-else-if="item.insurancetest">
                {{ item.insurancetest.name }} 
            </template> -->
            <template v-if ="isPaymentTypeValid">
                            {{ item.test.name }} <br><b class="small" v-if="userData.settings.show_detailed_lab_results">{{ commas(item.test.serviceprice) }}</b>
                
                          </template>
                          <template v-else>
                            {{ item.insurancetest.name }} <br><b class="small">{{ ("Insured") }}</b>
                
                          </template> 
        </td>
                      <td><span v-html="item.sample.name"></span></td>
                      <td><span v-html="item.result"></span></td>
                    </tr> 
                  </tbody>
                </table>
              </div> 
              
            <div class="mt-3 text-center">
                <h5 style="color: black;" class="my-4 text-center">Signature : .........................</h5>
                <p style="color:black;font-size:13px">Printed by : {{ userData.username }} | Via Afrimed Software | www.afrimed.com </p>
            </div>
        </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      patientTest:[],
      patientData:[],
      insuredtest:'',
      visit_date:new Date().toLocaleDateString('fr-CA'),
    };
  },
  created() {
    this.showlabresults();
    this.showpatientinfo();
  },
  computed: {
     
      isPaymentTypeValid() {
          return this.insuredtest!= 4;
          
         },

      },
  methods: {
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
    getLogo(name){
        let url = axios.defaults.baseURL;
        let imagelink = (url).slice(0,-3)+"logos/"+name;
        return imagelink;
      },
    //   getAge(dateString){
    //   let birth = new Date(dateString); let now = new Date(); let beforeBirth = ((() => {birth.setDate(now.getDate());birth.setMonth(now.getMonth()); return birth.getTime()})() < birth.getTime()) ? 0 : 1;
    //   return now.getFullYear() - birth.getFullYear() - beforeBirth;
    // },
    getAge(dateString) {
  let birth = new Date(dateString);
  let now = new Date();

  let years = now.getFullYear() - birth.getFullYear();
  let months = now.getMonth() - birth.getMonth();

  // Adjust years and months if the current month hasn't reached the birth month yet
  if (months < 0) {
    years--;
    months += 12;
  }

  // Adjust months if the current day hasn't reached the birth day yet
  if (now.getDate() < birth.getDate()) {
    months--;
    if (months < 0) {
      years--;
      months += 12;
    }
  }

  if (years > 0) {
    // return `${years} years and ${months} months old`;
    return `${years} yrs`;

  } else {
    return `${months} months old`;
  }
},
      async showpatientinfo(){
      this.visit_id=this.$route.query.id;
      let formData = new FormData();
      formData.append("visit_id", this.visit_id);
      let url = "/findpatientlabinfo";
      await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.patientData=response.data.patient;
        }
      })
    },
    async showlabresults(){
      this.visit_id=this.$route.query.id;
      let url = `/labpatientprofile/${this.visit_id}`;
      await axios.get(url).then((response) => {
        this.patientTest = response.data.results;
        this.insuredtest = response.data.results[0].patientvisit.payment_type;
        setTimeout(() => { window.print(); window.onafterprint=this.$router.go(-1); }, 2500);
      });
    },
  },
};
</script>